<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AjchZw/tc-custom/9780830847693.jpg?1696024729245" alt="This image is the cover for the book True Companions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Companions
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>When we quit sabotaging intimacy in our relationships by demanding unconditional love, we discover something much greater—the deeply satisfying, transformational love that is companionship.</strong> </p> <p>In these pages psychologist Kelly Flanagan shows how each of us has within ourselves, exactly the way we are, the gifts that are needed to cultivate the life-long relationships we are longing for, whether it is within marriage or friendship. He shows us how self-knowledge leads the way to growing in love for both God and others. He shows us how understanding our own loneliness can help us relieve the pressure on our companions. And he shows us how understanding our own psychological and emotional defenses can help us to make the choice to love more vulnerably.</p> <p>More than a marriage book, this is a companionship book. Anyone—from single young adults to elderly married couples, from the divorced to the widowed, from siblings to friends—can benefit from the wisdom it uncovers about what it means to be human and to be true companions.</p> <p>Groups, couples, and individuals can use the companion study guide for five sessions on how to show up in your most important relationships.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Flanagan, Ian Morgan Cron
      </h2>
      
      <p class="authorDescription body article"><p>Kelly Flanagan is a clinical psychologist and is the founder of Artisan Clinical Associates, a private practice in Naperville, Illinois, offering services to teens, adults, couples, and families. The author of <em>The Marriage Manifesto</em> and <em>Loveable</em>, he has also written for publications such as <em>Christianity Today</em>, <em>Reader's Digest</em>, and <em>Huffington Post</em>. In 2014, a letter he wrote to his daughter led to their appearance on the <em>TODAY Show</em>. Flanagan is a popular blogger and speaks regularly on topics related to marriage, parenting, and spiritual formation. He lives in Dixon, Illinois, with his wife, Kelly, and their three children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2db2e067